import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Endereco } from '../../models/endereco';

@Injectable({ providedIn: 'root' })
export class EnderecoApiService {
  private readonly _http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl + '/empresa';

  public findEnderecoByIdEmpresa(companyId: number): Observable<Endereco[]> {
    return this._http.get<Endereco[]>(`${this.baseUrl}/findEnderecoByEmpresa/${companyId}`);
  }
}
